import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { Button } from "@material-ui/core";
import { alertError } from "../../../../utils/logger";
import { getRunnerSymbolDecisionById } from "../../../../api/runnerSymbolDecisions";

function JsonBlock({ title, value }) {
  let text = "—";
  try {
    text =
      value === undefined || value === null
        ? "—"
        : typeof value === "string"
        ? value
        : JSON.stringify(value, null, 2);
  } catch {
    text = String(value);
  }
  return (
    <div className="mb-4">
      <h6 className="font-weight-bold">{title}</h6>
      <pre
        className="p-3 bg-light border rounded"
        style={{ maxHeight: "480px", overflow: "auto", fontSize: "12px" }}
      >
        {text}
      </pre>
    </div>
  );
}

export default function RunnerSymbolDecisionDetailPage() {
  const { id } = useParams();
  const history = useHistory();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getRunnerSymbolDecisionById(id)
      .then((res) => {
        if (res.status === 200) setDoc(res.data);
      })
      .catch((error) => {
        alertError({
          error,
          customMessage: "No se pudo cargar la decisión.",
        });
        setDoc(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <Card>
      <CardHeader title="Detalle decisión símbolo (hub)">
        <CardHeaderToolbar>
          <Button
            variant="outlined"
            onClick={() => history.push("/runner-symbol-decisions")}
          >
            Volver al listado
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {loading && <p>Cargando…</p>}
        {!loading && !doc && <p>No se encontró el documento.</p>}
        {!loading && doc && (
          <>
            <div className="row mb-3">
              <div className="col-md-6">
                <strong>ID:</strong> {String(doc._id)}
              </div>
              <div className="col-md-6">
                <strong>Fase:</strong> {doc.phase}
              </div>
              <div className="col-md-6 mt-2">
                <strong>reasonCode:</strong> {doc.reasonCode}
              </div>
              <div className="col-md-6 mt-2">
                <strong>strategyId:</strong> {doc.strategyId}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Exchange / par:</strong> {doc.exchange} ·{" "}
                {doc.canonicalSymbol}
              </div>
              <div className="col-md-6 mt-2">
                <strong>orderSymbol:</strong> {doc.orderSymbol || "—"}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Origen / estrategia:</strong> {doc.source} · {doc.strategy}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Creado:</strong>{" "}
                {doc.createdAt ? new Date(doc.createdAt).toLocaleString() : "—"}
              </div>
              <div className="col-md-6 mt-2">
                <strong>Actualizado:</strong>{" "}
                {doc.updatedAt ? new Date(doc.updatedAt).toLocaleString() : "—"}
              </div>
              {doc.watchStatus && (
                <div className="col-md-12 mt-2">
                  <strong>Vigilancia:</strong> {doc.watchStatus}
                  {doc.reasonDetail?.watchSession?.evaluationsCount != null && (
                    <>
                      {" "}
                      · evaluaciones:{" "}
                      {doc.reasonDetail.watchSession.evaluationsCount}
                    </>
                  )}
                  {doc.reasonDetail?.watchSession?.windowTimeMinutes != null && (
                    <>
                      {" "}
                      · ventana:{" "}
                      {doc.reasonDetail.watchSession.windowTimeMinutes} min
                    </>
                  )}
                  {doc.reasonDetail?.watchSession?.elapsedMinutes != null && (
                    <>
                      {" "}
                      · transcurrido:{" "}
                      {doc.reasonDetail.watchSession.elapsedMinutes} min
                    </>
                  )}
                </div>
              )}
            </div>
            {doc.reasonDetail?.latest && (
              <JsonBlock
                title="Última evaluación (pendiente / slope)"
                value={doc.reasonDetail.latest}
              />
            )}
            {Array.isArray(doc.reasonDetail?.history) &&
              doc.reasonDetail.history.length > 0 && (
                <JsonBlock
                  title={`Historial de evaluaciones (${doc.reasonDetail.history.length})`}
                  value={doc.reasonDetail.history}
                />
              )}
            {doc.reasonDetail?.closed && (
              <JsonBlock title="Cierre de vigilancia" value={doc.reasonDetail.closed} />
            )}
            {doc.reasonDetail?.watchSession && (
              <JsonBlock
                title="Sesión (watchSession)"
                value={doc.reasonDetail.watchSession}
              />
            )}
            <JsonBlock title="reasonDetail (completo)" value={doc.reasonDetail} />
          </>
        )}
      </CardBody>
    </Card>
  );
}
